import { withLoginUser } from 'src/api/user'
import { FeedbackLayout } from './FeedbackLayout'

export const FeedbackPage = withLoginUser(({ user }) => {
  return <FeedbackLayout user={user} />
})
